import React, { FC, useState } from 'react';
import { useStaticPermissions } from 'common/auth/Authorize';
import { DataTableToolbar } from '@utmost.co/utmost-design-system';
import { IconButton } from '@beeline.com/bp-design-system';
import { Importer } from '@oc/pages/importers_rsi/Importer';
import { ImportEntityTypeModel } from 'src/graphql/types';
import { RateCardsExportDialog } from '@oc/pages/settings/Engagements/RateCards/RateCardsExportDialog';

interface Props {
  message: string;
  onRateCardAdd: () => void;
  searchString: string | undefined;
}

export const RateCardsToolbar: FC<React.PropsWithChildren<Props>> = ({ message, onRateCardAdd, searchString }) => {
  const permissions = useStaticPermissions();
  const shouldDisplayImportAction = permissions({ permissionName: 'RATE_CARD' }).IMPORT;
  const shouldDisplayExportAction = permissions({ permissionName: 'RATE_CARD' }).READ;

  const [showImports, setShowImports] = useState(false);
  const [showExport, setShowExport] = useState(false);

  return (
    <>
      <DataTableToolbar
        searchProps={{ value: searchString }}
        addButtonProps={{ onAdd: onRateCardAdd }}
        message={message}
        beforeActions={
          <>
            {shouldDisplayImportAction ? (
              <>
                <IconButton
                  dataTest="import_data"
                  className="item"
                  onClick={() => setShowImports(true)}
                  iconName="download"
                  tooltipText="Import Data"
                />
                {showImports && (
                  <Importer
                    allowedImportTypes={[{ id: 'RATE_CARD', entityType: ImportEntityTypeModel.RateCard }]}
                    key="RATE_CARD"
                    setModal={setShowImports}
                  />
                )}
              </>
            ) : null}

            {shouldDisplayExportAction ? (
              <>
                <IconButton
                  dataTest="export_data"
                  className="item"
                  onClick={() => setShowExport(true)}
                  iconName="upload"
                  tooltipText="Export Data"
                />
                <RateCardsExportDialog open={showExport} onClose={() => setShowExport(false)} />
              </>
            ) : null}
          </>
        }
      />
    </>
  );
};
